module.exports = __webpack_public_path__ + "static/media/pupils.e4c24069.png";